import { useEffect, useState } from "react";

const navLinks = [
  { label: "最新进展", href: "#timeline" },
  { label: "追踪事件榜", href: "#board" },
  { label: "吃瓜分舱", href: "#channels" },
  { label: "存档速查", href: "#archive" },
  { label: "追更入口", href: "#entry" },
];

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950 text-background-50">
            <i className="ri-article-line text-base"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-display text-lg font-extrabold text-foreground-950">
              九色黑料
            </span>
            <span className="text-[10px] font-medium tracking-wide text-secondary-600">
              吃瓜第一现场
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <button
            type="button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-950"
          >
            <i className="ri-refresh-line text-sm"></i>
            刷新动态
          </button>
          <a
            href="#entry"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-eye-line text-sm"></i>
            围观入口
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="菜单"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 md:hidden"
        >
          <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-secondary-100"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-2 flex items-center gap-2">
              <button
                type="button"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm font-medium"
              >
                <i className="ri-refresh-line text-sm"></i>
                刷新动态
              </button>
              <a
                href="#entry"
                onClick={() => setOpen(false)}
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50"
              >
                围观入口
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}